import { useParams } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { IntegrationSettings } from 'modules/marketplace/components/IntegrationSettings'
import { locale } from 'modules/marketplace/components/utils/locales'
import { useGetMarketplaceIntegrations } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrations'
import {
  CompanyInstallations,
  CompanyInstallationsProvider,
} from 'modules/marketplace/store/collections/companyInstallations'

const IntegrationSettingsPage = () => {
  const companyInstallationCollection = useLazyRef(() => new CompanyInstallations()).current
  const { id } = useParams()
  const { access } = useCurrentSession()

  const datoFormatLocale = locale[access.locale]
  const { data: integrationsData, loading: loadingMarketplaceIntegrations } =
    useGetMarketplaceIntegrations(
      {
        datoIds: [String(id)],
        locale: datoFormatLocale,
      },
      !id
    )
  const integration = integrationsData.at(0)

  return (
    <CompanyInstallationsProvider collection={companyInstallationCollection}>
      <ResponsivePage.Body
        showHeader={false}
        variant="full"
        loading={loadingMarketplaceIntegrations}
        error={!integration}
      >
        {integration && <IntegrationSettings integration={integration} />}
      </ResponsivePage.Body>
    </CompanyInstallationsProvider>
  )
}

export default IntegrationSettingsPage
